import { useEffect, useState } from "react"
import { isRoot, setPage, useHub } from "../../../../core/Global"
import { useNavigate } from "react-router-dom"
import filteringProps from "../filtering/coupons.json";
import sortingProps from "../sorting/coupons.json";
import { DataTable, DataTableField } from "../../../../components/data/DataTable";
import { API_ROUTES } from "../../../../core/Constants";
import { CouponStatus, CouponTypes } from "../../../../core/Enums";
import Coupon from "../models/Coupon";
import FlexRow from "../../../../components/base/FlexRow";
import Icon from "../../../../components/base/Icon";
import Modal from "../../../../components/base/Modal";
import CouponGenerateForm from "../components/CouponGenerateForm";


export default function CouponsList() {

    const hub = useHub();
    const navigate = useNavigate();

    const [selectedItem, selectedItemSet] = useState<Coupon>();
    const [generateModal, generateModalSet] = useState<boolean>(false);
    const [deleteModal, deleteModalSet] = useState<boolean>(false);
    const [refresh, refreshSet] = useState<boolean>(false);

    useEffect(() => {
        if (!isRoot()) {
            navigate("/");
            return;
        }
        setPage("Coupons", "System");
    }, [])

    useEffect(() => {
        if (refresh) {
            setTimeout(() => {
                refreshSet(false)
            }, 500);
        }
    }, [refresh])


    const CodeCol = (data: Coupon) => (
        <span className="badge badge-light-primary fs-6 fw-bold" style={{ letterSpacing: 2 }}>
            {data.code}
        </span>
    )

    const TypeCol = (data: Coupon) => (
        <div className="fs-7">
            {
                data.couponType === CouponTypes.DollarDiscount ?
                    <span className="badge badge-light-success">Dollar Discount</span>
                    : data.couponType === CouponTypes.FreeSubscription ?
                        <span className="badge badge-light-info">Free Subscription</span>
                        : <span className="badge badge-light">-</span>
            }
        </div>
    )

    const ValueCol = (data: Coupon) => (
        <div className="fs-7 fw-bold">
            {
                data.couponType === CouponTypes.DollarDiscount ?
                    <>${data.amount}</>
                    : data.couponType === CouponTypes.FreeSubscription ?
                        <>{data.months} {data.months === 1 ? "Month" : "Months"}</>
                        : "-"
            }
        </div>
    )

    const ExpiryCol = (data: Coupon) => (
        <div className="fs-7">
            {
                data.neverExpires ?
                    <span className="badge badge-light-secondary">Unlimited</span>
                    : data.expireDate
            }
        </div>
    )

    const StatusCol = (data: Coupon) => (
        <div className="fs-7">
            {
                data.status === CouponStatus.Used ?
                    <span className="badge badge-secondary">Used</span>
                    : data.status === CouponStatus.Expired ?
                        <span className="badge badge-light-danger">Expired</span>
                        :
                        <span className="badge badge-success">Available</span>
            }
        </div>
    )

    const CreatedCol = (data: Coupon) => (
        <div>
            <div className="d-flex align-items-center">
                {data.createDate}
            </div>
            {
                data.creatorUser &&
                <FlexRow className="fs-8 mt-1">
                    <div>
                        <Icon icon="user" className="me-2" size={10} type="solid" />
                    </div>
                    <div className="fs-8">
                        By: {data.creatorUser.fullName}
                    </div>
                </FlexRow>
            }
        </div>
    )


    return (
        <>
            <DataTable
                objectName="Coupon"
                apiRoute={API_ROUTES.Coupons}
                filteringProps={filteringProps}
                sortingProps={sortingProps}
                addCustom={() => generateModalSet(true)}
                delete
                deleteCustom={data => {
                    selectedItemSet(data);
                    deleteModalSet(true);
                }}
                export
                exportTitle="Coupons"
                exportSenderNumbersUrl={API_ROUTES.Coupons + "sendernumbers"}
                exportColumns={[
                    { key: "code", label: "Code" },
                    { key: "type", label: "Type" },
                    { key: "amount", label: "Amount ($)" },
                    { key: "months", label: "Subscription Months" },
                    { key: "expiry", label: "Expiry Date" },
                    { key: "status", label: "Status" },
                    { key: "createdAt", label: "Created Date" },
                    { key: "creator", label: "Created By" },
                ]}
                refresh={refresh}>

                <DataTableField title="Code">
                    <CodeCol />
                </DataTableField>

                <DataTableField title="Type">
                    <TypeCol />
                </DataTableField>

                <DataTableField title="Value">
                    <ValueCol />
                </DataTableField>

                <DataTableField title="Expiry">
                    <ExpiryCol />
                </DataTableField>

                <DataTableField title="Status">
                    <StatusCol />
                </DataTableField>

                <DataTableField title="Created">
                    <CreatedCol />
                </DataTableField>

            </DataTable>

            {
                generateModal &&
                <CouponGenerateForm
                    onSave={() => refreshSet(true)}
                    onClose={() => generateModalSet(false)} />
            }

            {
                deleteModal && selectedItem &&
                <Modal id="modal-delete-coupon"
                    title="Delete Coupon"
                    buttonText="Delete Coupon"
                    buttonColor="danger"
                    open visible
                    onClose={() => {
                        deleteModalSet(false);
                        selectedItemSet(undefined);
                    }}
                    onConfirm={callback => {
                        hub.Post(API_ROUTES.Coupons + "delete", {
                            id: selectedItem.id
                        }, res => {
                            callback()
                            refreshSet(true)
                        })
                    }}>
                    <p className="ps-1">
                        Are you sure you want to delete coupon <strong>{selectedItem.code}</strong>?
                    </p>
                </Modal>
            }

        </>
    )
}
